"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _auth = require("@/utils/auth");
var _wxApi = require("@/api/wxApi");
var _systemSetting = require("@/api/systemSetting");
var _validate = require("@/utils/validate");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Index',
  components: {},
  data: function data() {
    var _this2 = this;
    var validateContent = function validateContent(rule, value, callback) {
      if (_this2.formValidate.type === 'text') {
        if (_this2.formValidate.contents.content === '') {
          callback(new Error('请填写规则内容'));
        } else {
          callback();
        }
      }
    };
    var validateSrc = function validateSrc(rule, value, callback) {
      if (_this2.formValidate.type === 'image' && _this2.formValidate.contents.mediaId === '') {
        callback(new Error('请上传'));
      } else {
        callback();
      }
    };
    var validateVal = function validateVal(rule, value, callback) {
      if (_this2.labelarr.length === 0) {
        callback(new Error('请输入后回车'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      visible: false,
      grid: {
        xl: 7,
        lg: 12,
        md: 10,
        sm: 24,
        xs: 24
      },
      delfromData: {},
      isShow: false,
      maxCols: 3,
      scrollerHeight: '600',
      contentTop: '130',
      contentWidth: '98%',
      modals: false,
      val: '',
      formatImg: ['jpg', 'jpeg', 'png', 'bmp', 'gif'],
      formatVoice: ['mp3', 'wma', 'wav', 'amr'],
      header: {},
      formValidate: {
        status: true,
        type: '',
        keywords: '',
        contents: {
          content: '',
          articleData: {},
          mediaId: '',
          srcUrl: '',
          articleId: null
        },
        id: null
      },
      ruleValidate: {
        val: [{
          required: true,
          validator: validateVal,
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择消息类型',
          trigger: 'change'
        }],
        content: [{
          required: true,
          validator: validateContent,
          trigger: 'blur'
        }],
        mediaId: [{
          required: true,
          validator: validateSrc,
          trigger: 'change'
        }]
      },
      labelarr: [],
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      }
    };
  },
  computed: {
    fileUrl: function fileUrl() {
      return https + "/wechat/reply/upload/image";
    },
    voiceUrl: function voiceUrl() {
      return https + "/wechat/reply/upload/voice";
    },
    httpsURL: function httpsURL() {
      return process.env.VUE_APP_BASE_API.replace('api/', '');
    }
  },
  watch: {
    $route: function $route(to, from) {
      if (this.$route.params.id) {
        // this.formValidate.keywords = this.$route.params.key
        this.details();
      } else {
        // this.labelarr = []
        // this.$refs['formValidate'].resetFields()
      }
    }
  },
  mounted: function mounted() {
    if (this.$route.params.id) {
      this.details();
    }
    if (this.$route.path.indexOf('keyword') === -1) {
      this.followDetails();
    }
  },
  methods: {
    change: function change(e) {
      this.$forceUpdate();
    },
    // 上传
    handleUploadForm: function handleUploadForm(param) {
      var _this3 = this;
      var formData = new FormData();
      formData.append('media', param.file);
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _systemSetting.wechatUploadApi)(formData, {
        type: this.formValidate.type === 'image' ? 'image' : 'voice'
      }).then(function (res) {
        loading.close();
        _this3.formValidate.contents.mediaId = res.mediaId;
        _this3.formValidate.contents.srcUrl = res.url;
        _this3.$message.success('上传成功');
      }).catch(function () {
        loading.close();
      });
    },
    changePic: function changePic() {
      var _this = this;
      this.$modalArticle(function (row) {
        _this.formValidate.contents.articleData = {
          title: row.title,
          imageInput: row.imageInput
        };
        _this.formValidate.contents.articleId = row.id;
      });
    },
    handleClosePic: function handleClosePic() {
      this.visible = false;
    },
    // 详情
    details: function details() {
      var _this4 = this;
      this.loading = true;
      (0, _wxApi.replyInfoApi)({
        id: this.$route.params.id
      }).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
          var info;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                info = res || null;
                _this4.formValidate = {
                  status: info.status,
                  type: info.type,
                  keywords: info.keywords,
                  id: info.id,
                  contents: {
                    content: JSON.parse(info.data).content,
                    mediaId: JSON.parse(info.data).mediaId,
                    srcUrl: JSON.parse(info.data).srcUrl,
                    articleData: JSON.parse(info.data).articleData
                  }
                };
                _this4.labelarr = info.keywords.split(',') || [];
                _this4.loading = false;
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function () {
        _this4.loading = false;
      });
    },
    // 关注回复，无效关键词详情
    followDetails: function followDetails() {
      var _this5 = this;
      this.loading = true;
      (0, _wxApi.keywordsInfoApi)({
        keywords: this.$route.path.indexOf('follow') !== -1 ? 'subscribe' : 'default'
      }).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(res) {
          var info;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                info = res || null;
                _this5.formValidate = {
                  status: info.status,
                  type: info.type,
                  keywords: info.keywords,
                  data: '',
                  id: info.id,
                  contents: {
                    content: JSON.parse(info.data).content || '',
                    mediaId: JSON.parse(info.data).mediaId || '',
                    srcUrl: JSON.parse(info.data).srcUrl || '',
                    articleData: JSON.parse(info.data).articleData || {}
                  }
                };
                _this5.loading = false;
              case 3:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function () {
        _this5.loading = false;
        // if (res.message === '数据不存在') return
        // this.$message.error(res.message)
      });
    },
    // 下拉选择
    RuleFactor: function RuleFactor(type) {
      switch (type) {
        case 'text':
          this.formValidate.contents.mediaId = '';
          this.formValidate.contents.srcUrl = '';
          this.formValidate.contents.articleData = {};
          break;
        case 'news':
          this.formValidate.contents.mediaId = '';
          this.formValidate.contents.content = '';
          this.formValidate.contents.srcUrl = '';
          this.formValidate.contents.articleData = {};
          break;
        default:
          this.formValidate.contents.content = '';
          this.formValidate.contents.mediaId = '';
          this.formValidate.contents.articleData = {};
      }
      // this.$refs['formValidate'].resetFields();
    },
    handleClose: function handleClose(tag) {
      var index = this.labelarr.indexOf(tag);
      this.labelarr.splice(index, 1);
    },
    addlabel: function addlabel() {
      var count = this.labelarr.indexOf(this.val);
      if (count === -1) {
        this.labelarr.push(this.val);
      }
      this.val = '';
    },
    // 保存
    submenus: (0, _validate.Debounce)(function (name) {
      var _this6 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this6.formValidate.keywords = _this6.labelarr.join(',');
          _this6.formValidate.data = JSON.stringify(_this6.formValidate.contents);
          if (_this6.$route.path.indexOf('keyword') !== -1) {
            _this6.$route.params.id ? (0, _wxApi.replyUpdateApi)({
              id: _this6.$route.params.id
            }, _this6.formValidate).then(/*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _this6.operation();
                    case 1:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              return function (_x3) {
                return _ref3.apply(this, arguments);
              };
            }()).catch(function (res) {
              _this6.$message.error(res.message);
            }) : (0, _wxApi.replySaveApi)(_this6.formValidate).then(/*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(res) {
                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _this6.operation();
                    case 1:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              return function (_x4) {
                return _ref4.apply(this, arguments);
              };
            }()).catch(function (res) {
              _this6.$message.error(res.message);
            });
          } else {
            _this6.$route.path.indexOf('follow') !== -1 ? _this6.formValidate.keywords = 'subscribe' : _this6.formValidate.keywords = 'default';
            _this6.formValidate.id !== null ? (0, _wxApi.replyUpdateApi)({
              id: _this6.formValidate.id
            }, _this6.formValidate).then(/*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(res) {
                return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      _this6.$message.success('操作成功');
                    case 1:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5);
              }));
              return function (_x5) {
                return _ref5.apply(this, arguments);
              };
            }()) : (0, _wxApi.replySaveApi)(_this6.formValidate).then(/*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(res) {
                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _this6.operation();
                    case 1:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
              return function (_x6) {
                return _ref6.apply(this, arguments);
              };
            }()).catch(function (res) {
              _this6.$message.error(res.message);
            });
          }
        } else {
          return false;
        }
      });
    }),
    // 保存成功操作
    operation: function operation() {
      var _this7 = this;
      this.$modalSure('继续添加').then(function () {
        setTimeout(function () {
          _this7.labelarr = [];
          _this7.val = '';
          _this7.$refs['formValidate'].resetFields();
          _this7.formValidate.contents.mediaId = '';
        }, 1000);
      }).catch(function () {
        setTimeout(function () {
          _this7.$router.push({
            path: "/appSetting/publicAccount/wxReply/keyword"
          });
        }, 500);
      });
    }
  }
};